// TODO: check on load if either component is selected based off #product ir ?product=product

jQuery(document).ready(function ($) {
  const highlight = document.querySelector(
    ".mobile-container .section-scroll__navigation-underline"
  );

  $(".mobile-container .section-scroll__navigation-item").on(
    "click",
    function () {
      // $(this).removeClass('inactive')
      const currentActive = $(".mobile-product.active");
      currentActive.removeClass("active").addClass("inactive");

      const product = $(this).data("product");

      const newActiveProduct = $(`.mobile-product--${product}`);

      setTimeout(function () {
        currentActive.addClass("gone");
        newActiveProduct.removeClass("inactive").removeClass("gone");
        newActiveProduct.addClass("active");
      }, 350);

      const currentActiveLink = document.querySelector(
        ".mobile-container .section-scroll__navigation-item.active"
      );

      if (currentActiveLink) {
        currentActiveLink.classList.remove("active");
      }

      $(this).addClass("active");

      highlightLink(this, highlight);
      handleImageUpdate(product);
    }
  );

  checkActiveMobileProduct();
});

function checkActiveMobileProduct() {
  const hash = window.location.hash;
  if (hash.length) {
    if (hash === "#propel") {
      const propelLink = document.querySelector(
        '.section-scroll__navigation-item[data-product="propel"]'
      );
      if (propelLink) {
        propelLink.click();
        handleImageUpdate("propel");
      }
    } else if (hash === "#revive") {
      const reviveLink = document.querySelector(
        '.section-scroll__navigation-item[data-product="revive"]'
      );
      if (reviveLink) {
        reviveLink.click();
        handleImageUpdate("revive");
      }
    }
  }
}
